import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '@/views/LoginView.vue';
import MainDashiew from '@/views/MainDashiew.vue';
import SeguradosView from '@/views/insideviews/segurados/SeguradosView.vue';
import EmpresasView from '@/views/insideviews/empresas/EmpresasView.vue';
import PlanosView from '@/views/insideviews/planos/PlanosView.vue';
import ApolicesView from '@/views/insideviews/apolices/ApolicesView.vue';
import AgendamentosView from '@/views/insideviews/agendamentos/AgendamentosView.vue';
import ListaDeAgendamentosView from '@/views/insideviews/listas_de_agendamentos/ListaDeAgendamentosView.vue';
import VisitasView from '@/views/insideviews/visitas/VisitasView.vue';
import UploadsView from '@/views/insideviews/uploads/UploadsView.vue';
import UsuarioDashView from '@/views/insideviews/dashboard_usuario/UsuarioDashView.vue';
import GerenciamentoRotasView from '@/views/insideviews/gerenciamento_rotas/GerenciamentoRotasView.vue';
import ListaDeAgendamentosRotaView from '@/views/insideviews/listas_de_agendamentos/ListaDeAgendamentosRotaView.vue';
import PropostasView from '@/views/insideviews/propostas/PropostasView.vue';
import TodasVisitasView from '@/views/insideviews/todas_visitas/TodasVisitasView.vue';
import ModelosPropostaView from '@/views/insideviews/modelo_proposta/ModelosPropostaView.vue';
import AtendimentosWhatsAppCommonView from '@/views/insideviews/atendimentos_whats_app/AtendimentosWhatsAppCommonView.vue';
import AtendimentosWhatsAppTriageView from '@/views/insideviews/atendimentos_whats_app/AtendimentosWhatsAppTriageView.vue';
import MovimentacaoView from '@/views/insideviews/movimentacao/MovimentacaoView.vue';
import MovimentacaoCommonView from '@/views/insideviews/movimentacao/MovimentacaoCommonView.vue';
import SeguradorasView from '@/views/insideviews/seguradoras/SeguradorasView.vue';
import IndicesIpcaView from '@/views/insideviews/indice_ipca/IndicesIpcaView.vue';
import DecessosView from '@/views/insideviews/decessos/DecessosView.vue';
import SolicitacoesClientesAdminView from '@/views/insideviews/solicitacoes_clientes/SolicitacoesClientesAdminView.vue';

// Módulo Cliente
import ClienteLoginView from '@/views/portal_cliente/ClienteLoginView.vue';
import ClienteMainDashView from '@/views/portal_cliente/ClienteMainDashView.vue';
import ClientePerfilView from '@/views/portal_cliente/ClientePerfilView.vue';
import ClienteHistoricoView from '@/views/portal_cliente/ClienteHistoricoView.vue';
import ClienteSolicitacoesView from '@/views/portal_cliente/ClienteSolicitacoesView.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/cliente-login',
    name: 'ClienteLogin',
    component: ClienteLoginView
  },
  {
    path: '/portal-cliente',
    name: 'ClienteMainDash',
    component: ClienteMainDashView,
    redirect: '/portal-cliente/perfil',
    children: [
      {
        path: 'perfil',
        name: 'ClientePerfil',
        component: ClientePerfilView,
      },
      {
        path: 'historico',
        name: 'ClienteHistorico',
        component: ClienteHistoricoView,
      },
      {
        path: 'solicitacoes',
        name: 'ClienteSolicitacoes',
        component: ClienteSolicitacoesView,
      }
    ]
  },
  {
    path: '/maindash',
    name: 'MainDash',
    component: MainDashiew,
    redirect: '/userdash',
    children: [
      {
        path: '/solicitacoes-portal',
        name: 'solicitacoes-portal',
        component: SolicitacoesClientesAdminView,
      },
      {
        path: '/userdash',
        name: 'userdash',
        component: UsuarioDashView,
      },
      {
        path: '/segurados',
        name: 'segurados',
        component: SeguradosView,
      },
      {
        path: '/empresas',
        name: 'empresas',
        component: EmpresasView,
      },
      {
        path: '/seguradoras',
        name: 'seguradoras',
        component: SeguradorasView,
      },
      {
        path: '/whats-app',
        name: 'whats-app',
        component: AtendimentosWhatsAppCommonView,
      },
      {
        path: '/whats-app/triagem',
        name: 'whats-app-triagem',
        component: AtendimentosWhatsAppTriageView,
      },
      {
        path: '/planos',
        name: 'planos',
        component: PlanosView,
      },
      {
        path: '/apolices',
        name: 'apolices',
        component: ApolicesView,
      },
      {
        path: '/agendamentos',
        name: 'agendamentos',
        component: AgendamentosView,
      }
      ,
      {
        path: '/listas-agendamentos',
        name: 'listaAgendamentos',
        component: ListaDeAgendamentosView,
      }
      ,
      {
        path: '/listas-rotas',
        name: 'listaRotas',
        component: ListaDeAgendamentosRotaView,
      }
      ,
      {
        path: '/visitas',
        name: 'visitas',
        component: VisitasView,
      }
      ,
      {
        path: '/todas-visitas',
        name: 'todasVisitas',
        component: TodasVisitasView,
      }
      ,
      {
        path: '/propostas',
        name: 'propostas',
        component: PropostasView,
      }
      ,
      {
        path: '/modelos-proposta',
        name: 'ModelosPropostaView',
        component: ModelosPropostaView,
        meta: { rolesInfo: ['admin', 'master.justech'] }
      },
      {
        path: '/indices-ipca',
        name: 'IndicesIpcaView',
        component: IndicesIpcaView,
        meta: { rolesInfo: ['admin', 'master.justech'] }
      },
      {
        path: '/decessos',
        name: 'DecessosView',
        component: DecessosView,
        meta: { rolesInfo: ['admin', 'master.justech'] }
      },
      {
        path: '/movimentacoes',
        name: 'movimentacoes',
        component: MovimentacaoView,
      }
      ,
      {
        path: '/movimentacoes/:id',
        name: 'movimentacao.show',
        component: MovimentacaoCommonView,
      }
      ,
      {
        path: '/uploads',
        name: 'uploads',
        component: UploadsView,
      }
      ,
      {
        path: '/gerenciamento-rotas',
        name: 'geremciamentoRotas',
        component: GerenciamentoRotasView,
      }
    ]
  },
]



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const myUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
  const myClientUser = JSON.parse(window.localStorage.getItem("myClientUser") || "{}");

  // Bloqueio das Rotas do Portal do Cliente
  if (to.path.startsWith('/portal-cliente')) {
    if (!myClientUser || Object.keys(myClientUser).length === 0) {
      next({ name: 'ClienteLogin' });
    } else {
      next();
    }
    return;
  }

  // Rotas normais (Consultores Administrativos)
  if (to.name !== 'Login' && to.name !== 'ClienteLogin' && (!myUser || Object.keys(myUser).length === 0)) {
    // Usuário não autenticado, redireciona para login principal
    next({ name: 'Login' });
  } else {
    // Usuário autenticado (ou indo pro Login Aberto), permite acesso
    next();
  }
});

export default router
